function render(props) {
    if (typeof props.children === 'function') {
        return props.children();
    }
    return props.children || null;
}
function When(_a) {
    var condition = _a.condition, children = _a.children;
    return condition ? render({ condition: condition, children: children }) : null;
}
export default When;

//# sourceMappingURL=index.js.map
